<h1 mat-dialog-title class="p-2 text-center">{{title}}</h1>
<div mat-dialog-content class="px-3 py-0">
    <div class="row justify-content-center">
        <div class="col-auto">
            <mat-form-field style="width: 100px;">
                <input matInput type="number" min="0" step="1" [(ngModel)]="number" [placeholder]="title" required>
            </mat-form-field>
        </div>
    </div>
    <div class="row">
        <div class="col-6 p-0">
            <button appPreventDoubleClick class="w-100 squared-flat-button" color="primary" mat-stroked-button (throttledClick)="onCancel()">
                Annuler
            </button>
        </div>
        <div class="col-6 p-0">
            <button appPreventDoubleClick class="w-100 squared-flat-button" color="warn" mat-stroked-button (throttledClick)="onConfirm()" [disabled]="!IsValidNumber">
                Valider
            </button>
        </div>
    </div>
</div>